import { render, staticRenderFns } from "./duoShareDetail.vue?vue&type=template&id=50e16870&scoped=true&"
import script from "./duoShareDetail.vue?vue&type=script&lang=js&"
export * from "./duoShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./duoShareDetail.vue?vue&type=style&index=0&id=50e16870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e16870",
  null
  
)

export default component.exports